module.exports = __webpack_public_path__ + "static/img/app_qrcode.4c0a7c8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/app_qrcode.jpeg
// module id = TEc7
// module chunks = 4